import styled from "styled-components";

export const Button = styled.button<{
  disabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.disabled ? "#9C9E9F" : "#7CCF63")};
  border: none;
  cursor: pointer;
  width: 100%;
  -webkit-box-shadow: 0px 4px 0px 0px rgba(65, 166, 42, 1);
  -moz-box-shadow: 0px 4px 0px 0px rgba(65, 166, 42, 1);
  box-shadow: 0px 4px 0px 0px rgba(65, 166, 42, 1);
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SiteButton = styled.button<{ color: string }>`
  color: #fff;
  display: table;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: var(--font-size-xxl);
  background: ${(props) => "var(" + props.color + ")"};
  font-weight: var(--font-weight-light);
  text-transform: uppercase;
  font-family: var(--font-title);
  border: none;
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  border-radius: 40px;
`;

export const TextButton = styled.p`
  color: #fff;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 15pt;
  margin-top: 10px;
  margin-bottom: 10px;
`;
